<div class="editor-bar">
  <button type="button" data-qa-id="bold-button" @click="handleBold" :class="{ 'is-active': editor.isActive('bold') }"
    class="editor-button">
    <BoldIcon />
  </button>
  <button type="button" data-qa-id="italic-button" @click="handleItalic" :class="{ 'is-active': editor.isActive('italic') }"
    class="editor-button">
    <ItalicIcon />
  </button>
</div>